/**
 * In-memory cache for Overview stats (company_stats, hired, integrity).
 * Used by StatsCards for stale-while-revalidate and by overviewPrefetch to warm cache.
 */
const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes

let cache = {
  stats: null,
  hiredStats: null,
  integrityStats: null,
  timestamp: 0,
};

export function isOverviewStatsCacheValid() {
  return cache.timestamp && Date.now() - cache.timestamp < CACHE_TTL_MS;
}

export function getCachedOverviewStats() {
  if (!isOverviewStatsCacheValid()) return null;
  return {
    stats: cache.stats,
    hiredStats: cache.hiredStats,
    integrityStats: cache.integrityStats,
  };
}

export function setCachedOverviewStats({ stats, hiredStats, integrityStats }) {
  cache.stats = stats != null ? { ...cache.stats, ...stats } : cache.stats;
  cache.hiredStats = hiredStats != null ? { ...cache.hiredStats, ...hiredStats } : cache.hiredStats;
  cache.integrityStats = integrityStats != null ? { ...integrityStats } : cache.integrityStats;
  cache.timestamp = Date.now();
}

export function clearOverviewStatsCache() {
  cache = { stats: null, hiredStats: null, integrityStats: null, timestamp: 0 };
}
